import {LocaleTag, SupportedTimezone} from "../../../../../../../api/generated";
import {SelectOption} from "../../../../../../elements/select/SelectDropdown";
import {getLocaleTagTitle} from "../../../../../../../utils/enumValueTitleUtil";

export const allDefaultLocaleOptions: SelectOption<LocaleTag>[] = [
    {label: getLocaleTagTitle(LocaleTag.EnGb), value: LocaleTag.EnGb},
    {label: getLocaleTagTitle(LocaleTag.EnUs), value: LocaleTag.EnUs},
    {label: getLocaleTagTitle(LocaleTag.EnCa), value: LocaleTag.EnCa},
    {label: getLocaleTagTitle(LocaleTag.FrFr), value: LocaleTag.FrFr},
    {label: getLocaleTagTitle(LocaleTag.FrCa), value: LocaleTag.FrCa},
    {label: getLocaleTagTitle(LocaleTag.DeDe), value: LocaleTag.DeDe},
    {label: getLocaleTagTitle(LocaleTag.EsEs), value: LocaleTag.EsEs},
    {label: getLocaleTagTitle(LocaleTag.JaJp), value: LocaleTag.JaJp},
    {label: getLocaleTagTitle(LocaleTag.ArAe), value: LocaleTag.ArAe}
];

export const allSupportedTimezoneOptions: SelectOption<SupportedTimezone>[] = [
    {label: "Europe/London", value: SupportedTimezone.EuropeLondon},
    {label: "Europe/Paris", value: SupportedTimezone.EuropeParis},
    {label: "Europe/Berlin", value: SupportedTimezone.EuropeBerlin},
    {label: "Europe/Madrid", value: SupportedTimezone.EuropeMadrid},
    {label: "Asia/Tokyo", value: SupportedTimezone.AsiaTokyo},
    {label: "Asia/Dubai", value: SupportedTimezone.AsiaDubai},
    {label: "America/New_York", value: SupportedTimezone.AmericaNewYork},
    {label: "America/Toronto", value: SupportedTimezone.AmericaToronto}
];

export type LocalePolicyPreview = {
    direction: "LTR" | "RTL";
    defaultTimezone: SupportedTimezone;
};

export const getLocalePolicyPreview = (locale: LocaleTag): LocalePolicyPreview => {
    switch (locale) {
        case LocaleTag.EnUs:
            return {direction: "LTR", defaultTimezone: SupportedTimezone.AmericaNewYork};
        case LocaleTag.EnCa:
        case LocaleTag.FrCa:
            return {direction: "LTR", defaultTimezone: SupportedTimezone.AmericaToronto};
        case LocaleTag.FrFr:
            return {direction: "LTR", defaultTimezone: SupportedTimezone.EuropeParis};
        case LocaleTag.DeDe:
            return {direction: "LTR", defaultTimezone: SupportedTimezone.EuropeBerlin};
        case LocaleTag.EsEs:
            return {direction: "LTR", defaultTimezone: SupportedTimezone.EuropeMadrid};
        case LocaleTag.JaJp:
            return {direction: "LTR", defaultTimezone: SupportedTimezone.AsiaTokyo};
        case LocaleTag.ArAe:
            return {direction: "RTL", defaultTimezone: SupportedTimezone.AsiaDubai};
        case LocaleTag.EnGb:
        default:
            return {direction: "LTR", defaultTimezone: SupportedTimezone.EuropeLondon};
    }
};

export const getSupportedTimezoneLabel = (timezone: SupportedTimezone): string => {
    const option = allSupportedTimezoneOptions.find((item) => item.value === timezone);
    return option?.label ?? "Europe/London";
};

export const toIntlLocaleTag = (locale: LocaleTag): string => locale.replace('_', '-');
